import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { AuthGuard } from './components/auth-guard';
import { Layout } from './components/layout';
import { AiAuditDetailPage } from './pages/ai-audit/ai-audit-detail-page';
import { AiAuditListPage } from './pages/ai-audit/ai-audit-list-page';
import { Dashboard } from './pages/dashboard';
import { DocumentsPage } from './pages/document/document-page';
import { ProcessorDetailPage } from './pages/processor-detail-page';
import { ProcessorInstanceDetailPage } from './pages/processor-instance/processor-instance-detail-page';
import { ProcessorsPage } from './pages/processors';
import { PromptsPage } from './pages/prompts';
import { SettingsPage } from './pages/settings';
import { UploadsListPage } from './pages/uploads/uploads-list-page';
import { UserSecretsPage } from './pages/user-secrets-page';

function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="documents/*" element={<DocumentsPage />} />
            <Route path="processors" element={<ProcessorsPage />} />
            <Route
              path="processors/:processorId"
              element={<ProcessorDetailPage />}
            />
            <Route
              path="instance/:id"
              element={<ProcessorInstanceDetailPage />}
            />
            <Route path="prompts" element={<PromptsPage />} />
            <Route path="ai-audit" element={<AiAuditListPage />} />
            <Route path="ai-audit/:id" element={<AiAuditDetailPage />} />
            <Route path="uploads" element={<UploadsListPage />} />
            <Route path="secrets" element={<UserSecretsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthGuard>
    </BrowserRouter>
  );
}

export default App;
